import {
    DeleteOutlined,
    EditOutlined,
    InboxOutlined,
    LinkOutlined,
} from '@ant-design/icons';
import { ReactNode } from 'react';

import { ProductActionList } from '../service/products.interface';

export const statusList = [
    {
        label: 'В наличии',
        key: '1',
        text: 'В наличии',
        value: 1,
        include: [2],
    },
    {
        label: 'Нет в наличии',
        key: '2',
        text: 'Нет в наличии',
        value: 2,
        include: [1, 3],
    },
];

interface ProductActionsProps {
    position: number;
    type: ProductActionList;
    component: ReactNode;
}

export const PRODUCT_ACTIONS = {
    archive: 'archive',
    delete: 'delete',
    edit: 'edit',
    copyDirectLink: 'copyDirectLink',
} as const;

export const PRODUCTS_VIEW = {
    cards: 'cards',
    table: 'table',
} as const;

export const ACTIONS: ProductActionsProps[] = [
    {
        position: 10,
        type: PRODUCT_ACTIONS.archive,
        component: <InboxOutlined />,
    },
    {
        position: 20,
        type: PRODUCT_ACTIONS.delete,
        component: <DeleteOutlined />,
    },
    {
        position: 30,
        type: PRODUCT_ACTIONS.edit,
        component: <EditOutlined />,
    },
    {
        position: 5,
        type: PRODUCT_ACTIONS.copyDirectLink,
        component: <LinkOutlined />,
    },
];

export const productsActionDefault = {
    label: 'Массовое действие',
    key: 'default',
};

export const productsActions = [
    { key: 'changeCategory', label: 'Переместить в категорию' },
];
